export default function creditLimitValidator({
  active_rcl_offers_amount_total,
  amount_balance_outstanding,
  amount_to_paydown,
  amount_to_paydown_with_interest,
  credit_remaining,
  credit_used,
  expected_unlock_date,
  is_credit_limit_locked,
  max_additional_credit_limit,
  max_potential_credit_limit,
  overdue_count,
  target_paydown_percent,
} = {}) {
  const availableCreditAfterDeduction = credit_remaining - active_rcl_offers_amount_total
  // TODO: Move other validations here
  return (
    credit_remaining !== undefined &&
    active_rcl_offers_amount_total !== undefined &&
    overdue_count !== undefined &&
    credit_remaining >= 1 &&
    availableCreditAfterDeduction >= 1 &&
    overdue_count === 0 &&
    !is_credit_limit_locked
  );
}



// WEBPACK FOOTER //
// ./src/utils/creditLimitValidator.js